/* istanbul ignore file */

import React, { ReactElement } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { Scheduling } from 'pages/Scheduling';
import { Incrementals } from 'pages/Incrementals';
import { ErrorBoundary } from 'components/ErrorBoundary/ErrorBoundary';
// import { BaselinesContainer } from 'pages/Baselines/BaselinesContainer';
import { Baselines } from 'pages/Baselines';

export const Router = (): ReactElement => {
  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/baselines" element={<Baselines />} />
        <Route path="/incrementals" element={<Incrementals />} />
        <Route path="/scheduling" element={<Scheduling />} />
        <Route path="*" element={<Navigate to="/scheduling" />} />
      </Routes>
    </ErrorBoundary>
  );
};
